$(function() {
  $(".buttons").each(function() {
    $(this).parent().append("<p class=\"buttons_title\"></p><div class=\"buttons_generated\" data-name=\"" + $(this).data("name") + "\"><div class=\"button_row\"></div></div><p class=\"buttons_back\">Go back</p>");
    for (var i = 0; i < $(this).children("li").length; i++) {
      if($(this).children("li").eq(i).data("url") !='')
      	$(".buttons_generated[data-name='" + $(this).data("name") + "']").children(".button_row").append('<div class="button ' + $(this).children("li").eq(i).data("class") + '" data-title="' + $(this).children("li").eq(i).data("title") + '" data-url="'+$(this).children("li").eq(i).data("url")+'">' + $(this).children("li").eq(i).html() + '</div>');
      else 
        $(".buttons_generated[data-name='" + $(this).data("name") + "']").children(".button_row").append('<div class="button" data-title="' + $(this).children("li").eq(i).data("title") + '">' + $(this).children("li").eq(i).html() + '</div>');
      $(".buttons_generated[data-name='" + $(this).data("name") + "']").find("ul").css("display", "none");
    }
    $(".button_row").addClass("FadeIn").data("title",$(this).data("title"));
    $(".buttons_title").eq(-1).text($(this).data("title"));
  });
  refresh();
  function refresh() {
    $(".button").unbind("click").click(function() {
      var url = $(this).data("url");
      if (url != "undefined" && url != undefined) {
        setTimeout(function() {
          document.location.href = url;
        }, 2000);
      }
      $(this).parents(".button_row").removeClass("FadeIn").removeClass("FadeInRight").addClass("FadeOut");
      $(this).parents(".buttons_generated").append("<div class=\"button_row\"></div>");
      for (var i = 0; i < $(this).children("ul").children("li").length; i++) {
        $(this).parents(".buttons_generated").children(".button_row").eq(-1).append('<div class="button ' + $(this).children("ul").children("li").eq(i).data("class") + '" data-title="' + $(this).children("ul").children("li").eq(i).data("title") + '" data-url="' + $(this).children("ul").children("li").eq(i).data("url") + '">' + $(this).children("ul").children("li").eq(i).html() + '</div>');
        $(".button").eq(-1).children("ul").css("display", "none");
      }
      $(this).parents(".buttons_generated").children(".button_row").eq(-1).removeClass("FadeOutRight").addClass("FadeIn").data("title",$(this).data("title"));
      $(this).parents().eq(2).children(".buttons_title").eq(-1).text($(this).data("title"));
      $(this).parents().eq(2).children(".buttons_back").eq(-1).css("display","block");
      refresh();
    });
    $(".buttons_back").unbind("click").click(function() {
      var clicked_button=$(this);
      console.log(clicked_button.parent().children(".buttons_generated").children(".button_row").eq(-2).data("title"));
      clicked_button.parent().children(".buttons_generated").children(".button_row").eq(-2).removeClass("FadeOut").addClass("FadeInRight");
      clicked_button.parent().children(".buttons_title").text( clicked_button.parent().children(".buttons_generated").children(".button_row").eq(-2).data("title") );
      clicked_button.parent().children(".buttons_generated").children(".button_row").eq(-1).removeClass("FadeIn").removeClass("FadeInRight").addClass("FadeOutRight");
      setTimeout(function() {
        clicked_button.parent().children(".buttons_generated").children(".button_row").eq(-1).remove();
      }, 800);
      if ( clicked_button.parent().children(".buttons_generated").children(".button_row").length == 2 ){ clicked_button.css("display","none"); };
      refresh();
    });
  };
});